import { render, staticRenderFns } from "./InvestorContact.vue?vue&type=template&id=ff2e3c28&"
import script from "./InvestorContact.vue?vue&type=script&lang=js&"
export * from "./InvestorContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports